<template lang="en">
<div class="container wc-container wc-container-720">
<Row :gutter="16">
  <Col span="24">
  <Form :model="form" label-position="top">
    <FormItem label="Poster Image">
      <img v-if="form.thumbUrl" :src="form.thumbUrl" style="width:100%;" alt="thumbUrl">
    </FormItem>
    <Upload
        type="drag"
        :action="uploadServer"
        :on-success="handleUpload"
        :format="['jpg','jpeg','png']"
        :max-size="10000"
        >

        <div style="padding: 20px 0">
            <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
            <p>Click or drag files here to upload</p>
        </div>
    </Upload>
    <FormItem label="Title">
      <Input v-model="form.title" placeholder=""></Input>
    </FormItem>
    <Row :gutter="16">
      <Col span="12">
      <FormItem label="Start">
        <date-picker input-class="ivu-input" width="100%" editable v-model="form.startAt" type="datetime" format="yyyy.MM.dd HH:mm" :time-picker-options="{start: '00:00',step: '00:30',end: '23:30'}" lang="en" :confirm="true" required></date-picker>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="End">
        <date-picker input-class="ivu-input" width="100%" editable v-model="form.endAt" type="datetime" format="yyyy.MM.dd HH:mm" :time-picker-options="{start: '00:00',step: '00:30',end: '23:30'}" lang="en" :confirm="true"></date-picker>
      </FormItem>
      </Col>
    </Row>
    </FormItem>
    <FormItem label="Interface Language">
      <Select v-model="form.interfaceLang" style="width:200px">
        <Option value="en">English</Option>
        <Option value="tr">Turkish</Option>
        <Option value="es">Spanish</Option>
      </Select>
    </FormItem>
    <FormItem label="Short Link">
      <Input v-model="form.shortLink" placeholder="">
        <span slot="prepend">{{appSettings.eventUrl}}</span>
        <Button
          slot="append"
          icon="ios-copy"
          v-clipboard:copy="appSettings.eventUrl+'/'+form.shortLink"
          v-clipboard:success="onLinkCopy"></Button>
      </Input>

    </FormItem>
    <FormItem label="Audio Room">
      <p style="width:100%">Enable Audio Room</p>
      <i-switch v-model="form.hasAudioRoom" style="position:absolute; right:0; top:0;" />
    </FormItem>
    <FormItem>
      <Button type="primary" size="large" @click="saveClick()" style="float:right;" v-if="!isSaving">Save</Button>
      <Button type="primary" size="large" style="float:right;" disable v-if="isSaving">Please wait</Button>
    </FormItem>
  </Form>
  </Col>
</Row>
</div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import feathersClient from "@/api/feathers-client";
import HashID from "@/helpers/hashid";
import $config from "@/config";

import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      form: {},
      isSaving: false
    };
  },
  components: {
    DatePicker
  },
  computed: {
    ...mapGetters("webcast", {
      webcast: "getCopy"
    }),
    ...mapGetters("appsettings", {
      appSettings: "getCopy"
    }),
    uploadServer() {
      return $config.uploadServer;
    }
  },
  created() {
    if (this.$route.params.id) {
      this.$data.form = _.cloneDeep(this.$store.state.webcast.copy);
    } else {
      /* Default interface lang */
      this.$data.form.interfaceLang = "en";
    }
  },
  methods: {
    ...mapActions("webcast", {
      createWebcastAction: "create",
      updateWebcastAction: "update"
    }),
    ...mapActions("stream", {
      createStreamAction: "create"
    }),
    saveClick() {
      if (this.$route.params.id) {
        this.update();
      } else {
        this.create();
      }
    },
    update() {
      this.$data.isSaving = true;
      console.log(this.$data.form);
      this.updateWebcastAction([this.$data.form._id, this.$data.form, {}]).then(
        response => {
          this.$data.isSaving = false;
          this.$Message.success("Webcast has been saved");
        }
      );
    },
    create() {
      console.log("creating");
      this.$data.isSaving = true;
      //this.$set(this.$data.form, 'currentSessionId', 111)
      this.$set(
        this.$data.form,
        "accountId",
        this.$store.state.account.currentId
      );

      console.log(this.$data.form);

      this.createWebcastAction(this.$data.form).then(response => {
        console.log(response._id);
        this.$store.commit("webcast/setCurrent", response._id);

        //Create default stream
        const streamData = {
          webcastId: this.$store.state.webcast.copy._id,
          name: "Default",
          streamId: HashID.generate()
        };

        this.createStreamAction(streamData).then(response => {
          this.$data.isSaving = false;
          this.$Message.success("Webcast has been saved");
          this.$router.push({
            name: "wcSettings",
            params: { id: this.$store.state.webcast.copy._id }
          });
        });
      });
    },
    handleUpload(res, file) {
      this.$set(this.$data.form, "thumbUrl", res);
    },
    onLinkCopy() {
      this.$Message.success("Link copied to clipboard");
    }
  }
};
</script>

<style>
</style>
